import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=a8a3cc9a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8a3cc9a')) {
      api.createRecord('a8a3cc9a', component.options)
    } else {
      api.reload('a8a3cc9a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=a8a3cc9a&", function () {
      api.rerender('a8a3cc9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OtNfxgsEp0LL/JS/offershelp.vue"
export default component.exports